import 'jquery';
import InputMask from '../input-masking';

/**
 * An input with a mask.
 *
 * @type {Object}
 */
const maskedInput = {

  /**
   * Initializes the maskedInput plugin.
   * @param  {Object} jQuery Under which element we want to
   *                                        track for events.
   */
  init: function() {

    // It uses the jquery boilerplate to build the plugin.
    // https://github.com/jquery-boilerplate/jquery-boilerplate
    //
    // Scroll down to the Plugin init method to get to the business logic.
    //
    // It is then made possible to fire the plugin on an DOM element like this:
    // $(yourElementSelector).amountSpinner();

    ;(function ( $, window, document, undefined ) {

      // Create the defaults once
      var pluginName = "maskedInput",
          defaults = {};

      // The actual plugin constructor
      function Plugin ( element, options ) {
          this.element = element;
          this.settings = $.extend( {}, defaults, options );
          this._defaults = defaults;
          this._name = pluginName;
          this.init();
      }

      // Avoid Plugin.prototype conflicts
      $.extend(Plugin.prototype, {

          init: function () {

            var $maskedInputField = $(this.element);
            new InputMask({ masked: '#' + $maskedInputField.attr('id') });
            $maskedInputField.addClass('hasInputMask');

          }


      });

      // A really lightweight plugin wrapper around the constructor,
      // preventing against multiple instantiations
      $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
          if ( !$.data( this, "plugin_" + pluginName ) ) {
            $.data( this, "plugin_" + pluginName, new Plugin( this, options ) );
          }
        });
      };

    })( jQuery, window, document );

  }


};

$(function() {

  maskedInput.init();

});
